import { z } from 'zod';
import { expectType } from './model.js';
import { EmptyPostBase, zFullPostBase, zPostBase } from './post.js';
export const zBasicPostFields = z.object({ postType: z.literal('basic') });
export const zBasicPost = zPostBase.merge(zBasicPostFields);
expectType({});
expectType({});
export const zFullBasicPost = zFullPostBase.merge(zBasicPostFields);
expectType({});
expectType({});
export const EmptyBasicPost = {
    ...EmptyPostBase,
    postType: 'basic'
};
